import React from 'react';

import { Box, Button } from '@mui/material';

import { OutlinedRectangularButtonPropTypes } from 'src/interfaces/iproptypes';

const OutlinedRectangularButton = ({
  height,
  width,
  colors,
  icon,
  text,
  handleOnClick,
  isFocused,
  borderRadius,
  fontWeight,
  fontSize,
  imageOverlay,
  disableHoverAnimation,
}: OutlinedRectangularButtonPropTypes) => {
  isFocused = isFocused ? isFocused : false;
  return (
    <Button
      sx={{
        position: 'relative',
        background: selectStyleByFocus(colors.backgroundColor, colors.color, isFocused),
        border: selectStyleByFocus(
          `2px solid ${colors.borderColor}`,
          `2px solid ${colors.color}`,
          isFocused
        ),
        color: selectStyleByFocus(colors.color, colors.backgroundColor, isFocused),
        height: height,
        borderRadius: borderRadius ? borderRadius : '10px',
        textTransform: 'capitalize',
        width: width,
        '&:hover': {
          background: disableHoverAnimation
            ? selectStyleByFocus(colors.backgroundColor, colors.color, isFocused)
            : colors.color,
          color: disableHoverAnimation
            ? selectStyleByFocus(colors.color, colors.backgroundColor, isFocused)
            : colors.backgroundColor,
          border: disableHoverAnimation
            ? selectStyleByFocus(
                `2px solid ${colors.borderColor}`,
                `2px solid ${colors.color}`,
                isFocused
              )
            : `2px solid ${colors.color}`,
        },
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '5px',
      }}
      onClick={handleOnClick}
    >
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          background: `url(${imageOverlay})`,
          backgroundSize: 'cover',
          mixBlendMode: 'multiply',
          opacity: 0.5,
          borderRadius: 2,
          zIndex: 0,
          "&:hover": {
            background: 'transparent',
          },
        }}
      />
      {icon ? icon : ''}
      
      <span
        style={{
          position: 'relative',
          zIndex: +1,
          fontWeight: fontWeight ? fontWeight : 500,
          fontSize: fontSize ? fontSize : 'inherit',
          pointerEvents: 'none',
        }}
      >
        {text ? text : ''}
      </span>
    </Button>
  );
};

const selectStyleByFocus = (attr1: string | number, attr2: string | number, isFocused: boolean) => {
  if (isFocused) {
    return attr2;
  }
  return attr1;
};

export default OutlinedRectangularButton;
